import { Link } from "react-router-dom";
import { Facebook, Instagram } from "lucide-react";
import { scrollToId } from "@/hooks/useSmoothScroll";
import BrandLockup from "@/components/BrandLockup";

const social = [
  { label: "Facebook", href: "https://www.facebook.com/profile.php?id=61592485093048", Icon: Facebook },
  { label: "Instagram", href: "https://www.instagram.com/kurpfalzautomation", Icon: Instagram },
];

export const Footer = () => {
  const year = new Date().getFullYear();
  const nav = [
    { label: "Problem", href: "#problem" },
    { label: "Leistungen", href: "#leistungen" },
    { label: "Ablauf", href: "#ablauf" },
    { label: "Kontakt", href: "#kontakt" },
  ];
  return (
    <footer data-testid="site-footer" className="bg-[#FAF8F2] border-t border-slate-200 py-14">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-8">
          <div className="max-w-md">
            <BrandLockup />
            <p className="mt-5 text-sm text-slate-500 leading-relaxed">
              Automatisierung von Terminplanung, Lead-Erfassung und Kundenkommunikation
              für kleine und mittlere Betriebe in Mannheim, Heidelberg, Ludwigshafen,
              Weinheim und der gesamten Rhein-Neckar-Region.
            </p>
            <div className="mt-6 flex items-center gap-3">
              {social.map(({ label, href, Icon }) => (
                <a
                  key={label}
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={label}
                  data-testid={`footer-social-${label.toLowerCase()}`}
                  className="inline-flex items-center justify-center w-10 h-10 rounded-full border border-slate-300 text-slate-500 hover:border-[#16273F] hover:text-[#16273F] transition-colors"
                >
                  <Icon className="w-4 h-4" strokeWidth={1.75} />
                </a>
              ))}
            </div>
          </div>
          <nav className="flex flex-wrap items-center gap-x-7 gap-y-2 text-sm text-slate-600">
            {nav.map((n) => (
              <button
                key={n.href}
                data-testid={`footer-nav-${n.href.replace("#", "")}`}
                onClick={() => scrollToId(n.href)}
                className="hover:text-[#16273F] transition-colors"
              >
                {n.label}
              </button>
            ))}
            <Link to="/fuer/handwerk" className="hover:text-[#16273F] transition-colors">Für Handwerk</Link>
            <Link to="/fuer/praxen" className="hover:text-[#16273F] transition-colors">Für Praxen</Link>
            <Link to="/fuer/immobilienverwalter" className="hover:text-[#16273F] transition-colors">Für Immobilienverwalter</Link>
            <Link to="/fuer/industrie" className="hover:text-[#16273F] transition-colors">Für Industrie & Architekten</Link>
            <Link to="/blog" className="hover:text-[#16273F] transition-colors">Blog</Link>
            <a href="mailto:ck-partners@gmx.net" data-testid="footer-email" className="hover:text-[#16273F] transition-colors">
              ck-partners@gmx.net
            </a>
            <a
              href="https://wa.me/4915233560557"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-whatsapp"
              className="hover:text-[#16273F] transition-colors"
            >
              WhatsApp: +49 152 33560557
            </a>
          </nav>
        </div>
        <div className="mt-10 pt-6 border-t border-slate-200 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 text-xs text-slate-400">
          <p>© {year} Kurpfalz Automation · eine Marke von CK &amp; Partners</p>
          <div className="flex items-center gap-6">
            <Link to="/impressum" data-testid="footer-impressum" className="hover:text-[#16273F] transition-colors">Impressum</Link>
            <Link to="/datenschutz" data-testid="footer-datenschutz" className="hover:text-[#16273F] transition-colors">Datenschutz</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
